<script setup lang="ts">
import { format } from "date-fns";
import type { Blog } from "~/types";

interface Props {
  data: Blog;
}

const props = defineProps<Props>();
const banner = computed(() => props.data.media.at(0)?.original_url);
</script>

<template>
  <NuxtLink :to="`/blogs/${data.slug}`">
    <article
      class="flex flex-col h-full w-full rounded-lg border bg-white shadow-xs overflow-hidden transition-shadow duration-300 hover:shadow-md"
    >
      <figure class="relative">
        <img
          :src="banner"
          :alt="data.title"
          class="h-56 w-full object-cover object-left-top"
        />

        <!-- Overlay -->
        <figcaption
          class="absolute bottom-0 flex w-full items-start sm:items-center justify-between bg-black/30 p-3 sm:p-4 text-sm text-white backdrop-blur-sm gap-2"
        >
          <div>
            <p class="font-semibold text-sm sm:text-base">
              <!-- {{ data.created_by.name }} -->
              {{ data.tabs[0] }}
            </p>
            <p class="mt-px text-xs">
              {{ format(new Date(data.published_date), "dd MMM yyyy") }}
            </p>
          </div>
          <!-- <p class="font-semibold text-xs sm:text-sm ml-auto">
            {{ data.tabs[0] }}
          </p> -->
        </figcaption>
      </figure>

      <section class="flex flex-col flex-1 px-3 sm:px-4 py-4 sm:py-5">
        <header>
          <h3
            class="mb-3 text-base sm:text-lg font-semibold text-gray-800 line-clamp-2"
          >
            {{ data.title }}
          </h3>
        </header>
        <div class="flex-1 mb-2 sm:mb-3">
          <p class="text-sm text-gray-600 line-clamp-3">
            {{ data.slogan }}
          </p>
        </div>
      </section>
    </article>
  </NuxtLink>
</template>
